var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:_vm.className,style:({color: _vm.color, fontSize: _vm.fontSize}),on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }